import {documentCategoryNames, serviceURL} from '../../util/uiconstants';
import { API_RESOURCES, createApiReadAction } from '../../util/api';
import Env from '../../util/env';
import * as types from '../actiontypes';

export const createLinkedResponse = (url, data) => {
	return {
		type: types.POST_LINKED_RESPONSE,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			}
		}
	};
};

// TODO Remove taskId from this action. We're getting documents related to a document. Not to a task
export const getLinkedDocuments = (engagementId, taskId, documentId) => {
	let url = `${Env.getBaseURL(serviceURL, engagementId)}LinkedForms/${documentId}`;

	return {
		type: types.GET_LINKED_DOCUMENTS,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		},
		taskId,
		documentId
	};
};

/**
 * Get Linked Forms for a given document id.
 * @param {Number} engagementId Engagement id.
 * @param {String} documentId Document id.
 * @param {Object} queryString Query string parameters as an object.
 * @param {Object} payload Action payload.
 * @returns Action for LinkedForms GetAll API.
 */
export function getLinkedDocumentsForMarkComplete(engagementId, documentId, queryString, payload) {

	return createApiReadAction(
		types.MARK_COMPLETE_GET_LINKED_FORMS,
		{[API_RESOURCES.ENGAGEMENTS]: engagementId, [API_RESOURCES.LINKEDFORMS]: documentId},
		queryString,
		{
			...payload,
			resolve: true
		}
	);
}

export function resetMarkComplete(){
	return {
		type: types.RESET_BULK_MARK_COMPLETE
	};
}